<template>
    <section ref="blog" class="blog__items">
        <div v-for="item in data" :key="item.Id" class="blog__item mb-7 position-relative">
            <h2 class="blog__title main-title main-title--alt mb-1">{{ item.Name }}</h2>
            <div class="blog__date small mb-3">{{ item.PublishDate }}</div>
            <div v-if="item.Picture != ''" class="blog__item-picture cover mb-2" :style="{ backgroundImage: `url('file/blog/thumb/600x600${item.Picture}')` }"></div>
            <div v-if="item.Tags != ''" class="blog__tags small mb-3">
                <strong>TAG:</strong>
                {{ item.Tags }}
            </div>
            <div class="mb-3" v-if="item.TextSimple != ''">{{ item.TextSimple }}</div>
            <a class="wbutton wbutton--small stretched-link" :href="item.Link">Czytaj więcej</a>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
export default {
    name: "Blog",
    data() {
        return {
            data: [],
            prevLoaded: -1,
            loaded: 0,
            isFetching: false,
            byTag: "",
        };
    },
    methods: {
        async fetch() {
            if (!this.isFetching) {
                this.isFetching = true;
                this.prevLoaded = this.loaded
                try {
                    let { data } = await this.$http.post("/blog", {
                        tag: this.byTag,
                        loaded: this.loaded
                    });
                    console.log(...data.data);
                    this.data.push(...data.data);
                    this.loaded = +this.loaded + data.data.length;
                } catch (error) {
                    console.log(error);
                }
                this.isFetching = false;
            }
        },
        onScroll(event) {
            console.log(this.$refs);
            const viewportHeight = window.innerHeight
            const blog = this.$refs.blog
            const blogRect = blog.getBoundingClientRect()
            let distance = blogRect.bottom - viewportHeight
            if (!this.isFetching && distance < 0 && this.loaded != this.prevLoaded) {
                this.fetch()
            }
        }
    },
    created() {
        document.addEventListener('scroll', this.onScroll)
        this.fetch();
    }, 
    beforeDestroy() {
        document.removeEventListener('scroll', this.onScroll)
    }
};
</script>

<style>
</style>